module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Regular.4edd0a38.ttf";